/**
 * Vuex module for ongoing video conference jitsi.
 */
const actions = {
  resize: function ({ commit }, { width, height }) {
    commit('SETWIDTH', width)
    commit('SETHEIGHT', height)
  },

  setPosition: function ({ commit }, { left, top }) {
    commit('SETTOP', top)
    commit('SETLEFT', left)
  },

  setLeft: function ({ commit }, left) {
    commit('SETLEFT', left)
  },

  setTop: function ({ commit }, top) {
    commit('SETTOP', top)
  },

  setWidth: function ({ commit }, width) {
    commit('SETWIDTH', width)
  },

  setHeight: function ({ commit }, height) {
    commit('SETHEIGHT', height)
  },

  setJitsi: function ({ commit }, jitsi) {
    commit('SETJITSI', jitsi)
  },

  setHasJoined: function ({ commit }, hasJoined) {
    commit('SETHASJOINED', hasJoined)
  },

  setDocked: function ({ commit }, docked) {
    commit('SETDOCKED', docked)
  },

  setMinimized: function ({ commit }, minimized) {
    commit('SETMINIMIZED', minimized)
  },

  setFullscreen: function ({ commit }, fullscreen) {
    commit('FULLSCREEN', fullscreen)
  }
}

const mutations = {
  RESIZE (state, { width, height }) {
    state.width = width
    state.height = height
  },

  SETLEFT (state, left) {
    state.left = left
  },

  SETTOP (state, top) {
    state.top = top
  },

  SETWIDTH (state, width) {
    state.width = width
  },

  SETHEIGHT (state, height) {
    state.height = height
  },

  SETJITSI (state, jitsi) {
    state.jitsi = jitsi
  },

  SETHASJOINED (state, hasJoined) {
    state.hasJoined = hasJoined
  },

  SETDOCKED (state, docked) {
    state.docked = docked
  },

  SETMINIMIZED (state, minimized) {
    state.minimized = minimized
  },

  FULLSCREEN (state, fullscreen) {
    state.fullscreen = fullscreen
  }
}

const state = {
  width: 400,
  height: 800,
  top: 0,
  left: 0,
  jitsi: null,
  hasJoined: false,
  docked: false,
  minimized: false,
  fullscreen: false
}

const getters = {
  width: state => state.width,
  height: state => state.height,
  left: state => state.left,
  top: state => state.top,
  jitsi: state => state.jitsi,
  hasJoined: state => state.hasJoined,
  docked: state => state.docked,
  minimized: state => state.minimized,
  fullscreen: state => state.fullscreen
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
